import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Generic hook to fetch data from a given URL, re-triggered when dependencies change.
 * @param url The URL to fetch data from (string or null/undefined to skip fetch)
 * @param deps Dependency array to control when the fetch is re-triggered
 */
export function useRemoteData<T = any>(
  url: string | null | undefined,
  deps: any[] = [],
): T | null {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    if (!url) {
      setData(null);
      return;
    }
    const controller = new AbortController();
    axios
      .get(url, { signal: controller.signal })
      .then((response) => {
        setData(response.data);
      })
      .catch((thrown) => {
        if (!axios.isCancel(thrown)) {
          console.log("Error while fetching remote data", thrown.message);
        }
      });
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);

  return data;
}
